/* External */
import { memo, useEffect, useRef } from 'react';

/* Components */
import LanderPage from '../../../components/LanderPage';

/* Utils */
import { PageType } from '../../../utils/constants';
import { useGtmLocalContext } from '../../../providers/GtmLocalProvider';
import { GTM_CATEGORIES, GTM_EVENT_NAMES, GTM_SUBCATEGORIES } from '../../../utils/googleTags';
import { useCountry } from '../../../providers/ConfigProvider';

function Kids() {
  const { commonTaggingEvent } = useGtmLocalContext();
  const country = useCountry();
  const tagsMountRef = useRef(true);

  useEffect(() => {
    if (tagsMountRef.current && country) {
      commonTaggingEvent({
        category: GTM_CATEGORIES.LIVE_CATALOG_SPORTS_KIDS_PAGE_DATA,
        subCategory: GTM_SUBCATEGORIES.PAGES.KIDS_PAGE,
        eventName: GTM_EVENT_NAMES.PAGE_VIEW,
      });
      tagsMountRef.current = false;
    }
  }, [commonTaggingEvent, country]);

  return <LanderPage pageId={PageType.KIDS} />;
}

export default memo(Kids);
